---
de:
  dashboard:
    gwh_ytd: GWh YTD
    m_currency_ytd: m{currency} YTD
    mm_48h: 48H
    of_ytd_average: von YTD-Durchschnitt
    plants_in_operation: Anlagen in Betrieb
    total_volume: Gesamte Menge
    volume_for_asset_type: "{type}-Menge"
